const PropTypes = require('prop-types');
//@vendors
const React = require('react');
const { connect } = require('react-redux');
// @components
const OKModal = require('components/commons/OKModal/OKModal');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @actions
const brokerAttentionPlanStartingModalActions = require('actions/brokerAttentionPlanStartingModal');

// @constants
const {
    PLANS_OPERATIONS_WARNING_MODAL
} = require('constants/flagBasedFeatures');
class BrokerAttentionPlanStartingModal extends React.Component {

    componentDidMount() {
        const { login, place } = this.props;
        const userName = login ? login.get('username') : '';

        this.props.init(userName, place);
    }

    render() {
        const { brokerAttentionPlanStartingModal, onAcceptHandler, onCloseHandler } = this.props;

        return (
            <FeatureTogglingRender notAllowedProductKey={PLANS_OPERATIONS_WARNING_MODAL}>
                <OKModal
                    description="brokerAttentionPlanStartingModal-content"
                    footerType="action"
                    isOpen={brokerAttentionPlanStartingModal.get('shouldDisplay')}
                    onCloseCallback={onCloseHandler}
                    onPrimaryButtonClick={onAcceptHandler}
                    primaryButtonText="brokerAttentionPlanStartingModal-understood"
                    title="brokerAttentionPlanStartingModal-title"
                />
            </FeatureTogglingRender>
        );
    }
}

BrokerAttentionPlanStartingModal.propTypes = {
    brokerAttentionPlanStartingModal: PropTypes.object,
    login: PropTypes.object,
    onAcceptHandler: PropTypes.func,
    onCloseHandler: PropTypes.func,
    init: PropTypes.func,
    place: PropTypes.string.isRequired
};

module.exports.constructor = BrokerAttentionPlanStartingModal;
module.exports.BrokerAttentionPlanStartingModal = connect(
    state => ({
        brokerAttentionPlanStartingModal: state.brokerAttentionPlanStartingModal,
        login: state.okLogin
    }), {
        onAcceptHandler: brokerAttentionPlanStartingModalActions.closeAndRemember,
        onCloseHandler: brokerAttentionPlanStartingModalActions.closeModal,
        init: brokerAttentionPlanStartingModalActions.init
    })(BrokerAttentionPlanStartingModal);